import { useLatestRef } from '@Common/hooks';
import { debounce } from '@quillbot/design-system';
import React, { MutableRefObject, useEffect } from 'react';
import { TypeOfSliders, useSliderVisibility } from './Slider';
import { getDocHeight, getScrollXY } from './utils';

export type UseDocumentScrollEndOptions = {
  offset: number;
  onScrollEnd: MutableRefObject<Function>;
};

export function useDocumentScrollEnd(options: UseDocumentScrollEndOptions) {
  useEffect(() => {
    const OFFSET = options.offset;
    const onScroll = debounce(() => {
      const documentHeight = getDocHeight();
      const currentScrollXY = getScrollXY();
      const scrollY = currentScrollXY[1];
      const position = scrollY + window.innerHeight;
      const LOAD_POSITION = documentHeight - OFFSET;
      // we have reached position before which next data must be loaded
      if (position >= LOAD_POSITION) {
        options.onScrollEnd.current();
      }
    });

    document?.addEventListener('scroll', onScroll);
    return () => {
      document?.removeEventListener('scroll', onScroll);
    };
  }, [options.offset, options.onScrollEnd]);
}

/**
 * useDocumentScrollEnd
 */

export type UseDSEIfSliderVisibleOptions = UseDocumentScrollEndOptions & {
  sliderId: TypeOfSliders;
};
export function useDSEIfSliderVisible(options: UseDSEIfSliderVisibleOptions) {
  const [slider] = useSliderVisibility();
  const visible = slider === options.sliderId;
  const onScrollEnd = useLatestRef((arg: any) => visible && options.onScrollEnd.current(arg));
  return useDocumentScrollEnd({ offset: options.offset, onScrollEnd });
}

export function DSEIfSliderVisible(props: React.PropsWithChildren<UseDSEIfSliderVisibleOptions>) {
  useDSEIfSliderVisible(props);
  return <>{props.children}</>;
}
